import { reactive, onMounted, onUnmounted } from "vue";
import AppointmentService from "@/services/office/appoinmentsService";
import TaskService from "../office/tasksService";
import ProcedureService from "../office/proceduresService";
import { SocketOffice } from "@/services/sockets/officeSocket";

export function useSidebarBadges() {
  // Estado reactivo para los contadores
  const counters = reactive({
    appointmentTodayCount: 0,
    toDoTaskCount: 0,
    toDoProcedureCounter: 0,
  });

  // --- LÓGICA TURNOS ---
  const fetchTurnos = async () => {
    try {
      const response = await AppointmentService.getAppointmentsByWeek();
      if (!response.success) return;

      const today = new Date();
      const daysOfWeek = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const todayName = daysOfWeek[today.getDay()];

      if (response.data && response.data.Appointments) {
        counters.appointmentTodayCount = response.data.Appointments[todayName] || 0;
      }
    } catch (e) {
      console.error("Error fetching turnos badge", e);
    }
  };

  // --- LÓGICA TAREAS ---
  const fetchTareas = async () => {
    try {
      const response = await TaskService.getToDoQuantity();
      if (response && (response.success || response.data !== undefined)) {
        counters.toDoTaskCount =
          typeof response.data === "number" ? response.data : 0;
      }
    } catch (e) {
      console.error("Error fetching tareas badge", e);
    }
  };

  // --- LÓGICA PROCEDES ---
  const fetchProcedures = async () => {
    try {
      const response = await ProcedureService.getToDoQuantity("procedure");
      if (response && (response.success || response.data !== undefined)) {
        counters.toDoProcedureCounter =
          typeof response.data === "number" ? response.data : 0;
      }
    } catch (e) {
      console.error("Error fetching procedures badge", e);
    }
  };

  // --- ACTUALIZACIÓN GLOBAL ---
  const refreshAll = () => {
    fetchTurnos();
    fetchTareas();
    fetchProcedures();
  };

  const setupSocketListeners = () => {
    SocketOffice?.on("tasks:update", fetchTareas);
    SocketOffice?.on("appoinments:update", fetchTurnos);
    SocketOffice?.on("procedures:update", fetchProcedures);
  };

  const removeSocketListeners = () => {
    SocketOffice?.off("tasks:update", fetchTareas);
    SocketOffice?.off("appoinments:update", fetchTurnos);
    SocketOffice?.off("procedures:update", fetchProcedures);
  };

  onMounted(() => {
    refreshAll();
    setupSocketListeners();
  });

  onUnmounted(() => {
    removeSocketListeners();
  });

  return {
    counters,
    refreshAll,
  };
}
